import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/get-all-account-points.reducers';
import { GetAllAccountPointsEffects } from './store/get-all-account-points.effects';

@NgModule({
  imports: [
    EffectsModule.forFeature([ GetAllAccountPointsEffects ]),
    StoreModule.forFeature('getAllAccountPoints', reducer),
  ],
})
export class GetAllAccountPointsModule {
}
